export class SupportingDocumentDTO {
     companyId: string;
     buId: string;
     auditProgramId: string;
     comments: string;
     auditScopeId: string;
     documentId: string;
     totalSize: string;
     fileName: string;
     fileType: string;
     isFinalReportReleased: string;
     isScopeItemNC: string;
     deptName: string;
     sectionName: string;
     businessProcessDescription: string;
     departmentId: string
     sectionCode: string;
     searchFileName: string = '';
     validationForAttachement: boolean;
     attachementCount: string;
     auditAreaId: string;
     pdcaStatus: string;
     observationNumber:string;
}